function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import { Button } from './Button';
const LinkWrapper = styled.span`
  a {
    color: #ffffff;
    text-decoration: none;
    &:hover {
      color: #fff;
      text-decoration: none;
    }
    svg {
      margin-left: 10px;
    }
  }
`;
export const ButtonLink = ({
  children,
  showLoader,
  template,
  link,
  isExternal,
  ...props
}) => {
  const LinkComponent = isExternal ? () => React.createElement("a", {
    href: link.url,
    target: link.target
  }, children) : () => React.createElement(Link, {
    to: link.url
  }, children);
  return (// eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(Button, _extends({
      template: template
    }, props), React.createElement(LinkWrapper, null, React.createElement(LinkComponent, null)))
  );
};
ButtonLink.propTypes = {
  isExternal: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  showLoader: PropTypes.bool,
  template: PropTypes.shape(),
  link: PropTypes.shape({
    target: PropTypes.string,
    url: PropTypes.string.isRequired
  }).isRequired
};
ButtonLink.defaultProps = {
  children: '',
  isExternal: false,
  showLoader: false,
  template: null
};